interface ProjectUpdate {
  date: string;
  title: string;
  description: string;
}

interface Project {
  id: string;
  slug: string;
  title: string;
  location: string;
  description: string;
  image: string;
  raised: number;
  goal: number;
  raisedLabel?: string;
  goalLabel?: string;
  completionLabel?: string;
  hideFundingAmounts?: boolean;
  category: string;
  unwtoGoals: number[];
  status: string;
  updates: ProjectUpdate[];
  galleryImages?: string[];
  partnerLogo?: string;
  partnerHighlights?: string[];
  // partner: string;
}

export const projects: Project[] = [
  {
    id: "1",
    slug: "empowering-young-athletes",
    title: "Empowering Young Athletes",
    location: "Himachal Pradesh, India",
    description:
      "Empowering Girls Football Team at Sanik School supporting young girls by providing complete sports dress for their upcoming football tournament, while promoting confidence, teamwork, and awareness of girls in sports.",
    image: "/Football%20Girl.png",
    raised: 1,
    goal: 1,
    raisedLabel: "Self Funded",
    goalLabel: "Goal Achieved",
    completionLabel: "80% completed",
    hideFundingAmounts: true,
    category: "Community Development",
    unwtoGoals: [8, 10],
    status: "Completed",
    updates: [
      {
        date: "2026-05-15",
        title: "Initiation of the Project",
        description:
          "<p>The journey of this initiative began when the team at Sainik School approached us with a heartfelt vision to encourage and motivate their young girls' football team through a sense of identity, pride, and team spirit ahead of their upcoming tournament.</p><p>Inspired by their commitment to empowering young athletes, especially girls in sports, we partnered on this meaningful initiative by designing and producing customised football jerseys for the team.</p><p>This initiative is about:</p><ul><li>Encouraging young girls to dream bigger through sports</li><li>Building confidence and team spirit</li><li>Supporting grassroots sports development</li><li>Creating visibility and motivation for future athletes</li></ul>",
      },
      {
        date: "2026-05-15",
        title: "Empowering Young Athletes",
        description:
          "<p><strong>Supporting the Girls Football Team at Sainik School</strong></p><p>We enlisted our in-house creative team and other partners to design the jerseys, aiming to make every young athlete feel confident, united, and proud when they step onto the field. This project is a meaningful step towards encouraging young girls in sports and creating equal opportunities through support, visibility, and motivation.</p><p>The jerseys were specially printed for the team and symbolize:</p><ul><li>Team spirit</li><li>Confidence & identity</li><li>Encouragement for girls in sports</li><li>A belief in young talent and dreams</li></ul><p>This marks the beginning of a larger journey where we aim to support and uplift young athletes through thoughtful community-driven initiatives.</p>",
      },
    ],
    galleryImages: [
      "/football1.jpeg",
      "/football.jpeg",
      "/football3.jpeg",
    ],
    partnerLogo: "/patnerlogo.png",
    partnerHighlights: [
      "Sainik School Sujanpur Tira - located in the Hamirpur district of Himachal Pradesh, is a premier residential institution under the Ministry of Defence. Established in 1978, it is dedicated to preparing students academically, physically, and mentally for careers as officers in the Indian Defence Forces",
    ],
    // partner: "Green Earth NGO",
  },
  {
    id: "2",
    slug: "empowering-the-next-generation-of-innovators-in-himachal-pradesh",
    title: "Empowering the Next Generation of Innovators in Himachal Pradesh",
    location: "Himachal Pradesh & Uttarakhand, India",
    description:
      "Empowering India Coder kids – Skills for Future Initiative Empowering rural kids with coding, digital literacy, and future-ready skills.",
    image:
      "https://images.unsplash.com/photo-1762614351385-0b3002530c1c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxlY28lMjB0b3VyaXNtJTIwbW91bnRhaW4lMjB2aWxsYWdlJTIwbGFuZHNjYXBlfGVufDF8fHx8MTc3NDg3MDQ3Nnww&ixlib=rb-4.1.0&q=80&w=1080",
    raised: 1,
    goal: 1,
    raisedLabel: "Self Funded",
    goalLabel: "Goal Achieved",
    completionLabel: "70% completed",
    hideFundingAmounts: true,
    category: "Education",
    unwtoGoals: [8, 10, 12],
    status: "Active",
    updates: [],
    // updates: [
    //   {
    //     date: "2026-03-20",
    //     title: "15 homestays certified",
    //     description:
    //       "Local families received training and certification for sustainable homestay operations.",
    //   },
    // ],
    // partner: "Mountain Heritage Foundation",
  }
  // {
  //   id: "3",
  //   title: "Books for Hope",
  //   location: "Delhi, India",
  //   description:
  //     "This initiative aims to bridge the educational gap by providing essential books and learning materials to underprivileged children. By donating books, we empower young minds to unlock their potential, foster a love for learning, and inspire a brighter future. Every book donated contributes to nurturing curiosity, knowledge, and a lifelong passion for education.",
  //   image:"/Books.jpg",
  //   raised: 580000,
  //   goal: 600000,
  //   category: "Education",
  //   unwtoGoals: [8, 10],
  //   status: "Active",
  //   updates: [],
  //   // updates: [
  //   //   {
  //   //     date: "2026-03-10",
  //   //     title: "E-commerce platform launched",
  //   //     description:
  //   //       "100+ artisans now have access to online marketplace for their products.",
  //   //   },
  //   // ],
  //   partner: "Craft Heritage Society",
  // }
//   {
//     id: "4",
//     title: "Education & Skill Development for Rural Youth",
//     location: "Uttar Pradesh, India",
//     description:
//       "Providing vocational training and education to rural youth for better employment opportunities.",
//     image:
//       "https://images.unsplash.com/photo-1765994898026-4fa84ade4a61?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjaGlsZHJlbiUyMGVkdWNhdGlvbiUyMHJ1cmFsJTIwc2Nob29sfGVufDF8fHx8MTc3NDg3MDQ3NXww&ixlib=rb-4.1.0&q=80&w=1080",
//     raised: 220000,
//     goal: 800000,
//     category: "Education",
//     unwtoGoals: [8, 10],
//     status: "Active",
//     updates: [],
//     partner: "Future Skills Foundation",
//   },
//   {
//     id: "5",
//     title: "Clean Water Access & Sanitation Project",
//     location: "West Bengal, India",
//     description:
//       "Installing water purification systems and sanitation facilities in underserved communities.",
//     image:
//       "https://images.unsplash.com/photo-1668961915523-884872e392f8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHdhdGVyJTIwd2VsbCUyMGNvbW11bml0eSUyMGFjY2Vzc3xlbnwxfHx8fDE3NzQ4NzA0Nzd8MA&ixlib=rb-4.1.0&q=80&w=1080",
//     raised: 650000,
//     goal: 650000,
//     category: "Infrastructure",
//     unwtoGoals: [10],
//     status: "Completed",
//     updates: [
//       {
//         date: "2026-03-01",
//         title: "Project completed successfully",
//         description:
//           "All 5 villages now have access to clean water and sanitation facilities.",
//       },
//     ],
//     partner: "Clean Water Initiative",
//   },
//   {
//     id: "6",
//     title: "Women Empowerment Through Textile Weaving",
//     location: "Tamil Nadu, India",
//     description:
//       "Training women in traditional textile weaving and providing equipment for self-employment.",
//     image:
//       "https://images.unsplash.com/photo-1759738096144-b43206226765?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx0cmFkaXRpb25hbCUyMHdlYXZpbmclMjB0ZXh0aWxlJTIwY3JhZnQlMjBpbmRpYXxlbnwxfHx8fDE3NzQ4NzA0Nzd8MA&ixlib=rb-4.1.0&q=80&w=1080",
//     raised: 380000,
//     goal: 550000,
//     category: "Women Empowerment",
//     unwtoGoals: [8, 10],
//     status: "Active",
//     updates: [],
//     partner: "Women Artisans Collective",
//   },
];
